<template>
  <div
    class="d-flex flex-column justify-center align-center"
    style="height: 70vh"
  >
    <v-icon class="icon" color="blue-grey">{{ icon }}</v-icon>
    <p
      v-show="title"
      class="subtitle-2 font-weight-medium blue-grey--text text--darken-1 text-center mt-3 mb-1"
      style="max-width: 300px;"
    >
      {{ title }}
    </p>

    <p
      v-show="message"
      class="body-2 blue-grey--text text-center"
      style="max-width: 250px;"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    icon: String,
  },
}
</script>
<style scoped>
.icon {
  color: var(--color-blue-grey-lighten1);
}
</style>
